/**
 * Bridge Locobuzz CookieBanner (localStorage lb_consent) → Complianz cookies
 * (cmplz_*). GTM still has legacy triggers that read cmplz_statistics /
 * cmplz_marketing; without these, HubSpot tracking tags fire late or not at all
 * even though the embed form submits directly.
 */
const CMPLZ_POLICY_ID = '25';
const MAX_AGE = 60 * 60 * 24 * 365;

function setCookie(name, value) {
  document.cookie = `${name}=${value}; path=/; max-age=${MAX_AGE}; SameSite=Lax`;
}

export function syncComplianzFromLbConsent(accepted) {
  if (typeof document === 'undefined') return;

  const allow = accepted ? 'allow' : 'deny';
  const categories = accepted
    ? '["functional","statistics","marketing"]'
    : '["functional"]';

  setCookie('cmplz_banner-status', 'dismissed');
  setCookie('cmplz_policy_id', CMPLZ_POLICY_ID);
  setCookie('cmplz_functional', 'allow');
  setCookie('cmplz_statistics', allow);
  setCookie('cmplz_marketing', allow);
  setCookie('cmplz_saved_categories', categories);
}

export function restoreComplianzFromStorage() {
  if (typeof window === 'undefined') return;
  try {
    const stored = localStorage.getItem('lb_consent');
    if (stored === 'accepted') syncComplianzFromLbConsent(true);
    else if (stored === 'declined') syncComplianzFromLbConsent(false);
  } catch {
    /* private browsing */
  }
}
